module.exports = __webpack_public_path__ + "img/RC6.12bae712.svg";